export default {
  old: {
    en: 'Price reduced from',
  },
  new: {
    en: 'On sale at',
  },
}
